// Shared constants for South Indian chart layout (4x4 grid)
// Used by SouthIndianChart, AshtavargaChakra, and NorthIndianChart

// Maps sign index (0=Aries) to grid position {row, col}
export const SIGN_GRID = [
  { row: 0, col: 1 },  // 0: Aries
  { row: 0, col: 2 },  // 1: Taurus
  { row: 0, col: 3 },  // 2: Gemini
  { row: 1, col: 3 },  // 3: Cancer
  { row: 2, col: 3 },  // 4: Leo
  { row: 3, col: 3 },  // 5: Virgo
  { row: 3, col: 2 },  // 6: Libra
  { row: 3, col: 1 },  // 7: Scorpio
  { row: 3, col: 0 },  // 8: Sagittarius
  { row: 2, col: 0 },  // 9: Capricorn
  { row: 1, col: 0 },  // 10: Aquarius
  { row: 0, col: 0 },  // 11: Pisces
];

export const CELL_SIZE = 100;
export const CHART_SIZE = CELL_SIZE * 4;

export const DEFAULT_SIGN_ABBREVS = [
  'Ari', 'Tau', 'Gem', 'Can', 'Leo', 'Vir',
  'Lib', 'Sco', 'Sag', 'Cap', 'Aqu', 'Pis',
];

export const SIGN_NAMES = [
  'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
  'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces',
];
